import React from "react";

import { Form } from "react-bootstrap";

export const Combo = ({
  nameCombo,
  onChangeCombo,
  dataOption,
  value,
  titleLabel,
}) => {
  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label className="label-forms-admin">{titleLabel}</Form.Label>
        <Form.Select
          className="inputs-forms-admin focus-admin-register"
          onChange={onChangeCombo}
          name={nameCombo}
          value={value}
        >
          <option value={"-1"}>Seleccione...</option>
          {dataOption.map((e, i) => {
            return (
              <>
                <option key={e.id_combo} value={e.id_combo}>
                  {e.nombreOption}
                </option>
              </>
            );
          })}
        </Form.Select>
      </Form.Group>
    </>
  );
};
